import { ReactNode } from 'react'
import styled from 'styled-components'
import { Flex, FlexProps, Text, useTooltip, TooltipText } from 'uikit'
import { BetPosition } from 'state/types'
import { useTranslation } from 'react-i18next'

interface TagProps extends FlexProps {
  bg?: string
  startIcon?: ReactNode
}

const StyledTag = styled(Flex)<{ bg: TagProps['bg'] }>`
  background-color: ${({ bg }) => `${bg}0D`};
  display: inline-flex;
`

const ImgArrow = styled.img`
  width: 12px;
  height: 12px;
`

const Imgs = {
  up: require('assets/images/prediction/up.svg').default,
  down: require('assets/images/prediction/down.svg').default,
}

export const Tag: React.FC<TagProps> = ({ bg = 'success', startIcon, children, onClick, ...props }) => {
  const icon = startIcon

  return (
    <StyledTag
      alignItems="center"
      justifyContent="center"
      borderRadius="12px"
      bg={`${bg}`}
      py="4px"
      px="8px"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'normal' }}
      {...props}
    >
      {icon}
      <Text textTransform="uppercase" color={bg} bold fontSize="14px" ml="4px">
        {children}
      </Text>
    </StyledTag>
  )
}

interface PositionTagProps extends FlexProps {
  betPosition: BetPosition
}

const PositionTag: React.FC<PositionTagProps> = ({ betPosition, children, ...props }) => {
  const { t } = useTranslation()
  const isUpPosition = betPosition === BetPosition.BULL
  const icon = isUpPosition ? <ImgArrow src={Imgs.up} /> : <ImgArrow src={Imgs.down} />
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text bold mb="4px">
        {t('PREDICTION_28')}
      </Text>
      <Text>{t('PREDICTION_29')}</Text>
    </>,
    { placement: 'right' }
  )

  if (betPosition === BetPosition.HOUSE) {
    return (
      <>
        {tooltipVisible && tooltip}
        <TooltipText ref={targetRef} color="secondary" fontWeight="300" textTransform="uppercase">
          <Flex alignItems="center">
            {t('PREDICTION_27')}
            {/* <InfoIcon width="16px" ml="4px" color="secondary" /> */}
          </Flex>
        </TooltipText>
      </>
    )
  }

  return (
    <Tag bg={isUpPosition ? '#14D89D' : '#F9479C'} startIcon={icon} {...props}>
      {children}
    </Tag>
  )
}

export default PositionTag
